import { $win, $body } from '../utils/globals'

$('.btn-menu').on('click', function(event) {
	event.preventDefault();

	$body.toggleClass('has-menu-opened');
});

$('.menu-item-has-children > a').on('click', function(event) {
    const target = $(this).parent();

if ($win.width() < 1024) {
    event.preventDefault();
        
    $(target)
        .toggleClass('is-active')
        .find('.sub-menu')
            .slideToggle()
        .end()
            .siblings()
                .removeClass('is-active')
                .find('.sub-menu')
                    .slideUp();
    };
});
